// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.EmailInput.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

import React from 'react';
import connect from 'share/enhancers/Izenda.Connect';
import GridLayout from 'share/components/controls/Izenda.GridLayout';
import Validator from 'share/components/hoc/Izenda.Validator';
import Select from 'share/components/controls/multiSelectBox/Izenda.Select';
import { REQUIRE_CONSTRAINTS } from 'logic/data/Izenda.EmailConstants';
import actions from './Izenda.EmailInputActions';
import { split } from 'lodash/fp';

const ValidatorSelect = Validator()(Select);

export default connect(actions)(function EmailInput(props: any) {
  const { localization, value, label, isRequired } = props;
  const customEmail = value ? split(';', value).map(item => ({ label: item, value: item })) :{};
  const emailOptions = props.emailOptions || [];
  const options = Object.assign(emailOptions, customEmail);
  return (
    <GridLayout.Row>
      <GridLayout.Col cols={2} className="Izenda-EmailPopup-Input">
        <span>{props.label}</span>
      </GridLayout.Col>
      <GridLayout.Col cols={10}>
        <div className="izenda-Email-Container">
          <ValidatorSelect
            value={value}
            containerClassName="u_fullWidth"
            multi
            delimiter=";"
            simpleValue
            joinValues
            options={options}
            valueKey='value'
            labelKey='label'
            onAddNew={props.addNewEmail}
            onBlur={props.addNewEmail}
            onChange={props.onChange}
            onBlurResetsInput={false}
            noResultsText={localization.getText('USER_MESSAGE_ENTER_TO_ADD_EMAIL')}
            isInsertOnBlur
            textboxMode
            validations={isRequired && REQUIRE_CONSTRAINTS}
            field={label}
            clearable={false}
          />
          <div className="u-posAbsolute u-iconAfterInput">
            <span
              onClick={props.openPopupAddUserPopup}
              className="icon-plus"
              title={localization.getText('USER_LABEL_SELECT_USER')}
            />
          </div>
        </div>
      </GridLayout.Col>
    </GridLayout.Row>
  );
});



// WEBPACK FOOTER //
// ./ui/share/components/controls/CommonPopup/Izenda.EmailInput.js